<template lang="pug">
  div(@click="$router.push(`/catalyst/${user.uid}`)").wrap-item-result-list.f.fm.flex-between.cursor-pointer
    div.f.fm.py16
      v-avatar(size="48px").mr16
        v-img(:src="user.iconPhotoURL")
      span.bold {{user.displayName}}
    div
      v-icon mdi-chevron-right
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-result-list {
  border-bottom: $basic_border;
}
</style>

<script>
import db from '@/components/utils/firebase'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    
  },
  async created () {

  },
  methods: {

  }
}
</script>
